import simplify from 'simplify-js';
import { DrawingTool, DrawingToolType, ShapeConfig } from './drawing-tool';

declare const config
const SIMPLIFICATION_FACTOR = config.drawingArea.tools.freeDrawing.simplificationFactor

export class FreeDrawingTool extends DrawingTool {

    protected readonly TOOL_TYPE: DrawingToolType = DrawingToolType.FREE_DRAWING;

    private closePath = false;
    private simplificationFactor = SIMPLIFICATION_FACTOR//1.5

    // This is used to perform line simplification at the end of the drawing
    // The data structure for containing points taken by the algorithm isn't 
    // the same as the one from Konva.js so we have to maintain a parallel 
    // list and convert it back at the end of drawing.
    private lineDP: any[] = []

    public constructor(strokeWidth: number, color, closePath?, simplificationFactor = SIMPLIFICATION_FACTOR) {
        super(strokeWidth, color)
        this.simplificationFactor = simplificationFactor;
        if (closePath) {
            this.closePath = closePath;
        }
    }

    public addNewShape(shapeX, shapeY, shapeId, color?: string, parameters?: any) {
        const newShape =
            {
                id: this.generateShapeId(shapeId),
                type: this.TOOL_TYPE,

                fill: this.DEFAULT_FILL_COLOR,
                opacity: this.DEFAULT_OPACITY,
                stroke: color || this.strokeColor,
                strokeWidth: this.strokeWidth,
                x: 0,
                y: 0,

                lineCap: 'round',
                lineJoin: 'round',
                points: [shapeX, shapeY],
                refresh: '', // used to trigger Vue.js watch as pushing in array doesn't do it
            } as ShapeConfig
        this.addPointInDPLine(shapeX, shapeY);
        return newShape;
    }

    public onTouchMove(currentShape, currentX, currentY, startX, startY) {

        currentShape.points.push(currentX, currentY);
        // Putting an arbitrary value to trigger Vue.js Watch
        currentShape.refresh = currentX

        this.addPointInDPLine(currentX, currentY);

    }

    public onTouchEnd(currentShape, endX, endY, startX, startY) {
        this.onTouchMove(currentShape, endX, endY, startX, startY)
        // Re-adding the first point at the en to close the path
        if (this.closePath) {
            this.onTouchMove(currentShape, startX, startY, 0, 0)
        }

        // Simplifying line to save space in memory
        currentShape.points = this.convertLineDPToArray();
    }

    public resetTool() {
        this.lineDP = []
    }

    private addPointInDPLine(pointX, pointY) {
        const point = { x: pointX, y: pointY }
        this.lineDP.push(point)
    }

    private convertLineDPToArray() {
        const flatArray: any[] = []
        const simplifiedLine = this.lineDP//simplify(this.lineDP, this.simplificationFactor)
        simplifiedLine.map((point) => {
            flatArray.push(point.x)
            flatArray.push(point.y)
        })
        return flatArray;
    }
}